import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    current: String,
    url: String,
  }

  change(event) {
    const newProvince = event.target.value

    if (newProvince && newProvince !== this.currentValue && document.hasFocus())
      Turbo.visit(`${this.urlValue}?province=${newProvince}`)
  }
}
